var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uploadDalog" }, [
    _c(
      "ul",
      [
        _vm._l(JSON.parse(_vm.uploadData.TYPE), function (item, index) {
          return _c("li", { key: index }, [
            _c("a", { attrs: { href: item.url } }, [_vm._v(_vm._s(item.name))]),
          ])
        }),
        _vm._v(" "),
        false
          ? _c(
              "Upload",
              {
                attrs: {
                  multiple: "",
                  action: "/p/cs/batchUpload",
                  name: "files",
                  data: _vm.uplData,
                  "on-success": _vm.onSuccess,
                  "on-error": _vm.onError,
                },
              },
              [
                _c(
                  "span",
                  { staticClass: "uplFile" },
                  [
                    _c("Icon", { attrs: { type: "md-cloud-upload" } }),
                    _vm._v("上传附件 "),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }